import React, { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';

export default function Login() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);
  
  const { login, currentUser } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (currentUser) {
      navigate('/');
    }
  }, [currentUser, navigate]);

  async function handleSubmit(e) {
    e.preventDefault();

    try {
      setError('');
      setLoading(true);
      await login(email, password);
      // Se der certo, o useEffect vai redirecionar
    } catch (err) {
      console.error("Erro Login:", err.message);
      
      // === TRATAMENTO DE ERROS PERSONALIZADO ===
      if (err.message === "USER_INACTIVE") {
        setError("Seu cadastro está INATIVO. Entre em contato com a liderança.");
      } 
      else if (err.message === "NO_PERMISSION") {
        setError("Seu acesso ao sistema foi revogado.");
      }
      else if (err.code === 'auth/invalid-credential' || err.code === 'auth/user-not-found' || err.code === 'auth/wrong-password') {
        setError('E-mail ou senha incorretos.');
      } 
      else if (err.code === 'auth/too-many-requests') {
        setError('Muitas tentativas. Tente novamente mais tarde.');
      } 
      else {
        setError('Falha ao fazer login. Tente novamente.');
      }
      
      setLoading(false); // IMPORTANTE: Destrava o botão
    }
  }

  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-100 p-4">
      <div className="max-w-md w-full bg-white rounded-xl shadow-lg overflow-hidden">
        <div className="bg-brand-blue p-8 text-center">
          <h2 className="text-3xl font-bold text-brand-gold">Escala Louvor</h2>
          <p className="text-white mt-2 opacity-90">Acesso ao Sistema</p>
        </div>

        <form onSubmit={handleSubmit} className="p-8">
          {error && (
            <div className="bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded mb-6 text-sm shadow-sm">
              <p className="font-bold">Atenção:</p>
              <p>{error}</p>
            </div>
          )}
          
          <div className="mb-4">
            <label className="block text-gray-700 text-sm font-bold mb-2">E-mail</label>
            <input 
              type="email" 
              className="w-full px-3 py-3 border border-gray-300 rounded focus:outline-none focus:border-brand-blue focus:ring-1 focus:ring-brand-blue"
              placeholder="seu@email.com"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
            />
          </div>

          <div className="mb-6">
            <label className="block text-gray-700 text-sm font-bold mb-2">Senha</label>
            <input 
              type="password" 
              className="w-full px-3 py-3 border border-gray-300 rounded focus:outline-none focus:border-brand-blue focus:ring-1 focus:ring-brand-blue"
              placeholder="******"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>

          <button 
            disabled={loading} 
            className={`w-full text-white font-bold py-3 px-4 rounded transition duration-200 shadow-md ${
              loading 
                ? 'bg-gray-400 cursor-not-allowed' 
                : 'bg-brand-blue hover:bg-blue-800 hover:shadow-lg'
            }`}
            type="submit"
          >
            {loading ? (
              <span className="flex items-center justify-center gap-2">
                <svg className="animate-spin h-5 w-5 text-white" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                  <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                  <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                </svg>
                Verificando...
              </span>
            ) : 'Entrar'}
          </button>
        </form>
      </div>
    </div>
  );
}